__webpack_require__.p = "https://admin.treatspa.net/";